import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth
export const signup = (data) => api.post('/auth/signup', data);
export const login = (data) => api.post('/auth/login', data);
export const logout = () => api.post('/auth/logout');
export const getCurrentUser = () => api.get('/auth/session');
export const handleOAuthSession = (sessionId) => api.post('/auth/oauth/session-data', {}, {
  headers: {
    'X-Session-ID': sessionId
  }
});
export const forgotPassword = (data) => api.post('/auth/forgot-password', data);
export const resetPassword = (data) => api.post('/auth/reset-password', data);

// Assets
export const getAssets = (category) => api.get('/assets', { params: { category } });
export const getAsset = (id) => api.get(`/assets/${id}`);
export const createAsset = (data) => api.post('/assets', data);
export const updateAsset = (id, data) => api.put(`/assets/${id}`, data);
export const deleteAsset = (id) => api.delete(`/assets/${id}`);

// Bookings
export const createBooking = (data) => api.post('/bookings', data);
export const getBookings = () => api.get('/bookings');

// Schedules
export const createSchedule = (data) => api.post('/schedules', data);
export const getSchedules = () => api.get('/schedules');
export const getAvailableDates = (assetId) => api.get(`/schedules/available/${assetId}`);

// Interest Form
export const submitInterest = (data) => api.post('/interest', data);
export const getInterestForms = () => api.get('/interest');

// Support
export const createTicket = (data) => api.post('/support', data);
export const getTickets = () => api.get('/support');

// FAQs
export const getFAQs = () => api.get('/faqs');

// Curation Packages
export const getCurationPackage = (slug) => api.get(`/curation-packages/${slug}`);

// Cart
export const getCart = () => api.get('/cart');
export const addToCart = (data) => api.post('/cart', data);
export const updateCartItem = (cartItemId, data) => api.put(`/cart/${cartItemId}`, data);
export const deleteCartItem = (cartItemId) => api.delete(`/cart/${cartItemId}`);
export const clearCart = () => api.delete('/cart');

// Product Interest Tracking
export const trackProductInterest = (data) => api.post('/users/track-product-interest', data);
export const getUserProductInterests = (userId) => api.get(`/users/${userId}/product-interests`);

// Cloudinary Signed URLs
export const generateSignedUrl = (fileUrl) => api.post('/generate-signed-url', { file_url: fileUrl });

// Admin
export const getAllUsers = () => api.get('/admin/users');
export const getAllBookings = () => api.get('/admin/bookings');
export const getAllSchedules = () => api.get('/admin/schedules');

export default api;
